import * as React from 'react';
import { useContext } from 'react';

import type { ENTERPRISE_MODAL_NAMES } from 'bundles/unified-common/constants/enterprise';

type EnterpriseModalManagerContextType = {
  modalToShow?: (typeof ENTERPRISE_MODAL_NAMES)[keyof typeof ENTERPRISE_MODAL_NAMES] | null;
  isAccessModalDismissed: boolean;
  setIsAccessModalDismissed: (argo0: boolean) => void;
  isAutoenrolledCoursesModalDismissed: boolean;
  setIsAutoenrolledCoursesModalDismissed: (arg0: boolean) => void;
  setHasShownLoginModal: (arg0: boolean) => void;
};

const EnterpriseModalManagerContext = React.createContext<EnterpriseModalManagerContextType | undefined>(undefined);

export const useEnterpriseModalManager = () => {
  const modalManager = useContext(EnterpriseModalManagerContext);

  return modalManager;
};

export default EnterpriseModalManagerContext;
